import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressBagEvents {
  milestoneActionSource: Subject<number> = new Subject<number>();
  milestoneAction$: Observable<number> = this.milestoneActionSource.asObservable();

  milestoneAchieved(value: number) {
    this.milestoneActionSource.next(value);
  }

  roundedInt(value: number, significantDigits: number): number {
    let digits: number[] = [];
    digits = value.toString().split('').map(Number);
    for (let i = digits.length - 1; i >= significantDigits; i--) {
      if (digits[i] >= 5) {
        digits[i - 1] = digits[i - 1] + 1;
      }
      digits[i] = 0;
    }
    return Number(digits.join(''));
  }
}
